export enum UserIntent {
  AI_HELPED_THE_USER = 'AI helped the user',
  USER_WANTS_HUMAN_SUPPORT = 'User wants human support',
  NEUTRAL = 'Neutral',
}
